import React from 'react';
import { Button, Form, Grid, Input, Loader, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { connect } from 'react-redux';
import { loadPlaceLKPS } from '../../../reduxFiles/placeLKPSActions';
import { toast } from 'react-toastify';


class CreateNewMobility extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            original: 0,
            semesterOptions: [],
            studentMobility: [],
            name: '',
            nameEn: '',
            nameOther: '',
            faculty: '',
            facultyEn: '',
            facultyOther: '',
            country: '',
            semester: '',
            academicYear: '',
            semesterNum: '',
            semesterNumOptions: [],
            otherLang: '',
            otherLangOptions: [],
            countries: [],

            nameErr: false,
            nameEnErr: false,
            nameOtherErr: false,
            facultyErr: false,
            facultyEnErr: false,
            facultyOtherErr: false,
            otherLangErr: false,
            countryErr: false,
            semesterErr: false,
            semesterNumErr: false,
            academicYearErr: false,

            student: JSON.parse(localStorage.getItem('student')),
        };

        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.fetchSemesterOptions = this.fetchSemesterOptions.bind(this);
        this.fetchLangOptions = this.fetchLangOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addMobilityStudent = this.addMobilityStudent.bind(this);
        this.closeAddMode = this.closeAddMode.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }

    componentDidMount() {
        // if (!this.props.placeLKPS.loaded && !this.props.placeLKPS.loading) {
        //     this.props.loadPlaceLKPS();
        // }
        this.fetchAcademicYearOptions();
        this.fetchLangOptions();

        axios.get('/study-program-semesters')
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });

        axios.get('/countries')
            .then(res => {
                this.setState({
                    countries: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })).filter(el=> el._key !== 'Nepoznato')
                });
            })
            .catch(err => {
                console.log('Failed to fetch citizenships');
            });
    }

    fetchLangOptions() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.id,
                        value: el.twoLetterCode,
                        text: el.name
                    }))
                });
            });
    }

    fetchAcademicYearOptions() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYearOptions: res.data.reverse().map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });
    }

    fetchSemesterOptions(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}/`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name
                    }))
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'academicYear') { this.setState({ semester: null }); this.fetchSemesterOptions(value); }
        this.setState({
            [name]: value
        });
    }

    closeAddMode() {
        this.props.closeAddMode();
    }

    addMobilityStudent() {
        if (!this.state.name || !this.state.semester || !this.state.academicYear || !this.state.semesterNum
            || !this.state.country || !this.state.faculty || !this.state.otherLang || !this.state.nameOther || !this.state.facultyOther) {
            if (!this.state.nameOther) {
                toast('Niste unijeli sve podatke. Prevod na izvorni jezik je obavezan!');
            } else { toast('Niste unijeli sve podatke'); }
            if (!this.state.name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (!this.state.country) { this.setState({ countryErr: true }); } else { this.setState({ countryErr: false }); }
            if (!this.state.faculty) { this.setState({ facultyErr: true }); } else { this.setState({ facultyErr: false }); }
            if (!this.state.otherLang) { this.setState({ otherLangErr: true }); } else { this.setState({ otherLangErr: false }); }
            if (!this.state.nameOther) { this.setState({ nameOtherErr: true }); } else { this.setState({ nameOtherErr: false }); }
            if (!this.state.facultyOther) { this.setState({ facultyOtherErr: true }); } else { this.setState({ facultyOtherErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.semesterNum) { this.setState({ semesterNumErr: true }); } else { this.setState({ semesterNumErr: false }); }
            if (!this.state.nameEn && this.state.facultyEn) { this.setState({ nameEnErr: true }); }
            if (this.state.nameEn && !this.state.facultyEn) { this.setState({ facultyEnErr: true }); }
        } else {
            this.setState({ loader: true });
            let transaltions = [];
            if ((this.state.nameEn || this.state.facultyEn) && this.state.otherLang !== 'en') {
                transaltions.push({
                    language: { twoLetterCode: (this.state.otherLangOptions.filter((e) => e.value === 'en') ? this.state.otherLangOptions.find((e) => e.value === 'en').value : null) },
                    universityName: this.state.nameEn,
                    facultyName: this.state.facultyEn,
                    originalLanguage: 0,
                });
            }
            if (this.state.nameOther || this.state.facultyOther) {
                transaltions.push({
                    language: { twoLetterCode: this.state.otherLang },
                    universityName: this.state.nameOther,
                    facultyName: this.state.facultyOther,
                    originalLanguage: this.state.original,
                });
            }
            let obj = {
                studentStudyProgram: { id: this.state.student.id },
                universityName: this.state.name,
                facultyName: this.state.faculty,
                country: { id: this.state.country },
                studyProgramSemester: { id: this.state.semesterNum },
                semester: { id: this.state.semester },
                translations: transaltions
            };
            axios.post('/student-study-program-mobility/add/', { ...obj })
                .then(res => {
                    toast('Studentu je uspješno dodana mobilnost.');
                    this.setState({
                        loader: false
                    });
                    this.resetForm();
                    this.closeAddMode();
                    this.props.getMobility();
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Mobility information for this semester is already added!') {
                        toast('Student već ima podatke o mobilnosti za ovaj semestar!');
                    } else {
                        toast('Došlo je do greške! Studentu nije kreirana mobilnost.');
                    }
                });
        }
    }

    resetForm() {
        this.setState({
            semester: null,
            academicYear: null,
            semesterNum: null,
            name: null,
            country: null,
            nameEn: null,
            nameOther: null,
            otherLang: null
        });
    }

    render() {
        // if (this.props.placeLKPS.error) return <div>ERROR </div>;
        // if (!this.props.placeLKPS.loaded) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        // const { countries } = this.props.placeLKPS;
        if (this.state.error) return <div>Greška</div>;
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary clearing>
                        <Form noValidate>
                            <Grid columns={4} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field required>
                                            <label>Država</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite državu"
                                                value={this.state.country}
                                                onChange={this.handleInputChange}
                                                name="country"
                                                options={this.state.countries}
                                                search
                                                fluid
                                                error={this.state.countryErr}
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.academicYearErr}>
                                            <label>Akademska godina</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite akademsku godinu"
                                                value={this.state.academicYear}
                                                onChange={this.handleInputChange}
                                                name="academicYear"
                                                options={this.state.academicYearOptions}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.semesterErr}>
                                            <label>Semestar</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite semestar"
                                                value={this.state.semester}
                                                onChange={this.handleInputChange}
                                                name="semester"
                                                options={this.state.semesterOptions.filter(e => e.name._key !== 'other')}
                                                disabled={!this.state.academicYear}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.semesterNumErr}>
                                            <label>Broj semestra</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite semestar"
                                                value={this.state.semesterNum}
                                                onChange={this.handleInputChange}
                                                name="semesterNum"
                                                options={this.state.semesterNumOptions.filter(e => e.name !== 'ostalo')}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={2} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Univerzitet"
                                            value={this.state.name}
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                            name="name"
                                            placeholder="Unesite naziv univerziteta"
                                            error={this.state.nameErr}
                                        />
                                        <Form.Field
                                            control={Input}
                                            label="Univerzitet (engleski jezik)"
                                            value={this.state.nameEn}
                                            onChange={(e) => this.setState({ nameEn: e.target.value })}
                                            name="nameEn"
                                            placeholder="Unesite naziv univerziteta"
                                            error={this.state.nameEnErr}
                                            disabled={this.state.otherLang === 'en'}
                                        />
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Fakultet/akademija"
                                            value={this.state.faculty}
                                            onChange={(e) => this.setState({ faculty: e.target.value })}
                                            name="faculty"
                                            placeholder="Unesite naziv fakulteta/akademije"
                                            error={this.state.facultyErr}
                                        />
                                        <Form.Field
                                            control={Input}
                                            label="Fakultet/akademija (engleski jezik)"
                                            value={this.state.facultyEn}
                                            onChange={(e) => this.setState({ facultyEn: e.target.value })}
                                            name="facultyEn"
                                            placeholder="Unesite naziv fakulteta/akademije"
                                            error={this.state.facultyEnErr}
                                            disabled={this.state.otherLang === 'en'}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment>
                                            <Form.Field error={this.state.otherLangErr} required>
                                                <label>Izvorni jezik</label>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite izvorni jezik"
                                                    value={this.state.otherLang}
                                                    onChange={this.handleInputChange}
                                                    name="otherLang"
                                                    // options={this.state.countries.find((e) => (e.id === this.state.country) && (e.officialLanguage.twoLetterCode === 'en')) ? this.state.otherLangOptions.filter((e) => (e.value !== 'bs')) : this.state.otherLangOptions.filter((e) => (e.value !== 'bs') && (e.value !== 'en'))}
                                                    options={this.state.otherLangOptions.filter((e) => (e.value !== 'bs'))}
                                                    search
                                                    disabled={!this.state.country}
                                                    fluid
                                                />
                                            </Form.Field>
                                            <Form.Field
                                                required
                                                control={Input}
                                                label="Univerzitet (izvorni jezik)"
                                                value={this.state.nameOther}
                                                onChange={(e) => this.setState({ nameOther: e.target.value, original: 1 })}
                                                name="nameOther"
                                                placeholder="Unesite naziv univerziteta"
                                                error={this.state.nameOtherErr}
                                                disabled={!this.state.country}
                                            />
                                            <Form.Field
                                                required
                                                control={Input}
                                                label="Fakultet/akademija (izvorni jezik)"
                                                value={this.state.facultyOther}
                                                onChange={(e) => this.setState({ facultyOther: e.target.value, original: 1 })}
                                                name="facultyOther"
                                                placeholder="Unesite naziv fakulteta/akademije"
                                                error={this.state.facultyOtherErr}
                                                disabled={!this.state.country}
                                            />
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <br />

                            <Button color="blue" basic="true" floated="right" onClick={this.closeAddMode}>Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                onClick={this.addMobilityStudent}
                            >
                                Dodaj
                            </Button>
                        </Form>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}

const mapStateToProps = ({ placeLKPS }) => ({ placeLKPS });
export default connect(mapStateToProps, { loadPlaceLKPS })(CreateNewMobility);



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/CreateNewMobility.js